import { render, staticRenderFns } from "./CommonSignContainer.vue?vue&type=template&id=1fc34e28&scoped=true"
import script from "./CommonSignContainer.vue?vue&type=script&lang=js"
export * from "./CommonSignContainer.vue?vue&type=script&lang=js"
import style0 from "./CommonSignContainer.vue?vue&type=style&index=0&id=1fc34e28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc34e28",
  null
  
)

export default component.exports